<template lang="pug">
pr-wrapper.animated.align-items-stretch.py-4(
  bg,
  :zi="index",
  :class="{ active: activated }",
  nv-sleep-protect,
  nv-exit-protect,
  v-nv:scope="'marquee'",
  @nv-exit.native="close",
  @nv-back.native="close",
  @nv-enter.native="close"
) 
  #marquee-container.flex-grow-1.border-right
  pr-button.background.mx-5(small, v-nv) {{ $t('Close') }}
</template>

<script>
export default {
  name: "marquee",
  data() {
    return {
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0"
    }
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "106" : "0"

      if (nval) {
        _$.marquee(this.payload.data, this.payload.repeat, this.payload.speed / 10, "marquee-container")
      }
    }
  },
  mounted() {
    _$.vue.$on("marquee", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close()

      if (!this.validatePayload(payload)) return false
      if (this.activated) this.payload.reject()

      this.payload = payload

      await this.$nextTick()

      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }

      await _$.nav.sync("marquee", true)
      await _$.sleep(200)
      this.activated = true
    },
    validatePayload(payload) {
      let validate = true

      if (typeof payload !== "object") validate = false
      else if (!payload.data || !payload.speed) validate = false
      else if (typeof payload.resolve !== "function") validate = false
      else if (typeof payload.reject !== "function") validate = false

      if (!validate && typeof payload === "object" && payload.reject) payload.reject()

      return validate
    },
    select() {
      this.close(true, true)
    },
    close(reason, resolve) {
      if (!this.activated) return false

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (resolve) return this.payload.resolve(resolve)
      else return this.payload.reject()
    }
  }
}
</script>

<style lang="scss">
#marquee {
  z-index: 99999;
  position: absolute;
  display: flex;
  overflow: hidden;
  bottom: 0;
  right: 0;
  left: 0;
  transform: translateY(100%);
  visibility: hidden;
  box-shadow: 0px -15px 20px 13px rgba(0, 0, 0, 0.45);

  #marquee-container {
    overflow: hidden;
    position: relative;

    h5 {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(100%, -50%);
      white-space: nowrap;
      margin-bottom: 0 !important;
    }
  }
  &.active {
    transform: translateY(0);
    visibility: visible;
  }
}
</style>
